<template>
  <span>
    <template v-for="(item, index) in computedItems">
      <div :key="item._id">
        <v-list-item
          class="pr-0 pl-0"
          :class="{
            'packing-item--missing': !itemBoxSelections[item._id] || !itemBoxSelections[item._id].length,
          }"
        >
          <v-list-item-avatar tile :size="!isMobile ? 100 : 50" class="ml-3 mr-4">
            <v-img :src="item.product_image_link || defaultImage" />
          </v-list-item-avatar>
          <v-list-item-content :class="{ 'packing-content--mobile': isMobile }">
            <v-list-item-content class="pb-2 pt-0">{{ item.product_title }}</v-list-item-content>
            <v-list-item-subtitle v-if="item.is_customized" class="primary--text">
              {{ $t('product.customization') }}: {{ $t('product.yes') }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.product_sku">
              {{ $t('product.sku') }}: {{ item.product_sku }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.barcode || item.product_ean">
              {{ $t('product.barcode') }}: {{ item.barcode || item.product_ean | formatBarCode() }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.product_size">
              {{ $t('product.size') }}: {{ item.product_size }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.product_color">
              {{ $t('product.color') }}: {{ item.product_color }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $t('product.price') }}:
              <del v-if="item.product_default_price && item.product_default_price > item.product_sale_price">
                {{ item.product_default_price | formatPrice(subOrder.currency) }}
                {{ subOrder.currency ? subOrder.currency.code : subOrder.currency_code }}
              </del>
              {{ item.product_sale_price | formatPrice(subOrder.currency) }}
              {{ subOrder.currency ? subOrder.currency.code : subOrder.currency_code }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="subOrder.current_status === 'to_pickup'">
              {{ $t('product.quantityToHandOver') }}:
              {{ item.current_status === 'cancelled' ? 0 : item.validated_quantity }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-else-if="isScanStep && item.current_status !== 'cancelled'"
              :class="{ isScanned: itemIsEntirelyScanned(item, item.nb_scanned) }"
            >
              {{ $t('product.preparedQuantity') }}: {{ item.nb_scanned ? item.nb_scanned : 0 }}/
              <span v-if="item.current_status === 'partially_validated'">{{ item.validated_quantity }}</span>
              <span v-else>{{ item.product_quantity }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              {{ $t('product.quantity') }}: {{ item.validated_quantity ? item.validated_quantity : 0 }}/{{
                item.product_quantity
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <!-- Desktop: button in action slot on the right -->
          <v-list-item-action v-if="!isMobile" class="align-self-center ml-2" style="min-width: 0">
            <v-btn large color="primary" depressed tile @click="$emit('open-box-selection', item)">
              {{ $t('subOrder.chooseBoxes') }}
            </v-btn>
            <div v-for="(entry, idx) in itemBoxSelections[item._id] || []" :key="idx" class="text-center mt-1 body-2">
              {{ entryLabel(entry) }}: {{ entry.quantity }}
            </div>
          </v-list-item-action>
        </v-list-item>
        <!-- Mobile: button below product, right-aligned, 50% width -->
        <div v-if="isMobile" class="d-flex justify-end px-3 pb-2">
          <div style="width: 50%">
            <v-btn
              style="height: auto; padding: 4px 8px; width: 100%"
              color="primary"
              depressed
              tile
              @click="$emit('open-box-selection', item)"
            >
              {{ $t('subOrder.chooseBoxes') }}
            </v-btn>
            <div
              v-for="(entry, idx) in itemBoxSelections[item._id] || []"
              :key="idx"
              class="text-center mt-1 box-entry-summary"
            >
              {{ entryLabel(entry) }}: {{ entry.quantity }}
            </div>
          </div>
        </div>
      </div>
      <v-divider :key="`d-${index}`" />
    </template>
  </span>
</template>

<script>
  import { formatBoxEntryLabel } from '@/helpers/helper'

  export default {
    name: 'PackingProductList',
    props: {
      subOrder: {
        type: Object,
        required: true,
      },
      isScanStep: {
        type: Boolean,
        default: false,
      },
      itemBoxSelections: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        defaultImage: require('@/assets/img/products/product_default.png'),
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      computedItems() {
        if (this.subOrder.current_status === 'partially_confirmed') {
          return this.subOrder.items.filter((item) => item.current_status !== 'cancelled')
        }
        return this.subOrder.items
      },
    },
    methods: {
      itemIsEntirelyScanned(item, nbScanned) {
        const qtyScanned = nbScanned ? nbScanned : 0
        return (
          (item.current_status === 'partially_validated' && qtyScanned >= item.validated_quantity) ||
          (item.current_status === 'validated' && qtyScanned >= item.product_quantity)
        )
      },
      entryLabel(entry) {
        return formatBoxEntryLabel(entry, this.$i18n.locale)
      },
    },
  }
</script>

<style scoped>
  .packing-item--missing {
    border-left: 3px solid #ef8236;
    padding-left: 8px !important;
  }

  /* eslint-disable-next-line */
  .packing-content--mobile >>> .v-list-item__subtitle,
  /* eslint-disable-next-line */
  .packing-content--mobile.v-list-item__content {
    font-size: 0.75rem !important;
  }

  .box-entry-summary {
    font-size: 0.5625rem;
  }
</style>
